var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path0, _path1, _g6, _path10, _path11, _path12, _g7, _path13, _g8, _path14, _path15, _g9, _path16, _path17, _g0, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPikko3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 91,
    viewBox: "0 0 53 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4493 21.5751C3.4493 21.5751 22.5958 20.2821 22.7262 40.5725C2.13968 40.4437 3.4493 21.5751 3.4493 21.5751Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12218_20790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 19,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2666 19.9375H24.2634V41.8485H2.2666V19.9375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12218_20790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8447 41.6835L22.7188 41.6777C16.0789 41.6338 10.9145 39.706 7.36783 35.9381C1.81529 30.0435 2.31603 21.8524 2.33973 21.5073L2.40492 20.5565L3.3738 20.4892C3.3738 20.4892 3.64639 20.4688 4.12638 20.4688C7.39746 20.4688 23.7143 21.44 23.8388 40.5719L23.8447 41.6835Z",
    fill: "url(#paint0_linear_12218_20790)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_12218_20790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 0,
    width: 17,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1943 0H34.1231V30.4209H18.1943V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_12218_20790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2524 30.036L25.4613 29.2461C20.7947 24.5889 18.528 19.6246 18.7236 14.4906C19.0287 6.45164 25.2568 1.01046 25.5235 0.785204L26.2524 0.15625L26.9842 0.785204C27.2509 1.01046 33.479 6.45164 33.7842 14.4906C33.9797 19.6246 31.7131 24.5889 27.0464 29.2461L26.2524 30.036Z",
    fill: "url(#paint1_linear_12218_20790)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5972 21.5751C49.5972 21.5751 30.4536 20.2821 30.3203 40.5725C50.9097 40.4437 49.5972 21.5751 49.5972 21.5751Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_12218_20790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 19,
    width: 23,
    height: 23
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8135 19.9375H50.8103V41.8485H28.8135V19.9375Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_12218_20790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2012 41.6835L29.2101 40.5719C29.3345 21.44 45.6514 20.4688 48.9195 20.4688C49.4025 20.4688 49.675 20.4892 49.675 20.4892L50.641 20.5565L50.7091 21.5073C50.7328 21.8524 51.2335 30.0406 45.681 35.9381C42.1373 39.706 36.97 41.6338 30.3271 41.6777L29.2012 41.6835Z",
    fill: "url(#paint2_linear_12218_20790)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_12218_20790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 32,
    width: 53,
    height: 59
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.744141 32.3945H52.3229V91.0014H0.744141V32.3945Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_12218_20790)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_12218_20790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 32,
    width: 51,
    height: 60
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7878 91.0053V32.4453C35.613 32.4336 35.4412 32.4336 35.2664 32.4336H17.8206V91.0053H35.7878ZM13.3496 91.0053H17.8206V32.4453H17.7228C10.4933 32.4453 4.14668 38.2697 3.6252 45.3813L1.18078 78.084C0.64449 85.1809 6.12296 91.0053 13.3496 91.0053ZM39.6367 91.0053C46.8663 91.0053 52.3418 85.1809 51.8084 78.0693L49.3611 45.3696C48.8396 38.4306 42.7804 32.7174 35.776 32.4453V91.0053H39.6367Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_12218_20790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8459 91.0053H1.17969V32.3984H51.8459V91.0053Z",
    fill: "url(#paint3_linear_12218_20790)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_12218_20790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 30,
    width: 24,
    height: 24
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.9141H23.0931V53.7144H0V30.9141Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_12218_20790)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_12218_20790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 30,
    width: 24,
    height: 24
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5466 30.918C5.17032 30.918 0 36.0198 0 42.3181C0 48.6135 5.17032 53.7183 11.5466 53.7183C17.9228 53.7183 23.0931 48.6135 23.0931 42.3181C23.0931 36.0198 17.9228 30.918 11.5466 30.918Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_12218_20790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 30.918H23.0931V53.7183H0V30.918Z",
    fill: "#F8F3F3"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_12218_20790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 35,
    width: 15,
    height: 15
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35547 35.1875H18.7553V49.4077H4.35547V35.1875Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_12218_20790)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_12218_20790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 35,
    width: 15,
    height: 15
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5583 35.1875C7.58207 35.1875 4.3584 38.3703 4.3584 42.2991C4.3584 46.2249 7.58207 49.4077 11.5583 49.4077C15.5346 49.4077 18.7583 46.2249 18.7583 42.2991C18.7583 38.3703 15.5346 35.1875 11.5583 35.1875Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_12218_20790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3584 35.1875H18.7583V49.4077H4.3584V35.1875Z",
    fill: "#3D1F1E"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.005 44.1692C14.005 42.4581 15.297 41.2246 16.9924 41.2246C15.3758 41.2246 14.0064 39.9107 14.0064 38.2787C14.0064 39.8952 12.7283 41.2246 11.0176 41.2246C12.7283 41.2246 14.005 42.5202 14.005 44.1692Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.005 38.2773L14.0064 38.2787M14.0064 38.2787C14.0064 39.9107 15.3758 41.2246 16.9924 41.2246C15.297 41.2246 14.005 42.4581 14.005 44.1692C14.005 42.5202 12.7283 41.2246 11.0176 41.2246C12.7283 41.2246 14.0064 39.8952 14.0064 38.2787Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_12218_20790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 60,
    width: 17,
    height: 16
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4248 60.7227H34.7624V75.0331H18.4248V60.7227Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_12218_20790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5925 78.781C26.0562 78.781 25.5259 78.7239 25.0014 78.6072C24.474 78.4929 23.9644 78.3214 23.4696 78.095C22.9748 77.8663 22.5037 77.5896 22.0592 77.2604C21.6118 76.9311 21.2 76.556 20.8207 76.1376C20.4415 75.7168 20.1037 75.2617 19.8074 74.7678C19.5082 74.2762 19.2563 73.7548 19.0519 73.206C18.8474 72.6594 18.6934 72.0946 18.5867 71.5138C18.483 70.9307 18.4326 70.3453 18.4326 69.7507C18.4326 69.1584 18.483 68.5707 18.5867 67.9899C18.6934 67.4091 18.8474 66.8443 19.0519 66.2954C19.2563 65.7489 19.5082 65.2275 19.8074 64.7359C20.1037 64.2419 20.4415 63.7869 20.8207 63.3661C21.2 62.9477 21.6118 62.5726 22.0592 62.2433C22.5037 61.914 22.9748 61.6374 23.4696 61.4087C23.9644 61.1823 24.474 61.0108 25.0014 60.8964C25.5259 60.7798 26.0562 60.7227 26.5925 60.7227C27.1288 60.7227 27.6592 60.7798 28.1836 60.8964C28.711 61.0108 29.2207 61.1823 29.7155 61.4087C30.2103 61.6374 30.6814 61.914 31.1258 62.2433C31.5732 62.5726 31.9851 62.9477 32.3643 63.3661C32.7436 63.7869 33.0814 64.2419 33.3777 64.7359C33.6769 65.2275 33.9288 65.7489 34.1332 66.2954C34.3376 66.8443 34.4917 67.4091 34.5984 67.9899C34.7021 68.5707 34.7525 69.1584 34.7525 69.7507C34.7525 70.3453 34.7021 70.9307 34.5984 71.5138C34.4917 72.0946 34.3376 72.6594 34.1332 73.206C33.9288 73.7548 33.6769 74.2762 33.3777 74.7678C33.0814 75.2617 32.7436 75.7168 32.3643 76.1376C31.9851 76.556 31.5732 76.9311 31.1258 77.2604C30.6814 77.5896 30.2103 77.8663 29.7155 78.095C29.2207 78.3214 28.711 78.4929 28.1836 78.6072C27.6592 78.7239 27.1288 78.781 26.5925 78.781Z",
    fill: "#3D1F1E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_12218_20790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 68,
    width: 15,
    height: 11
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3584 68.9062H33.4857V78.9315H19.3584V68.9062Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_12218_20790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.598 73.9176C33.598 74.1638 33.5506 74.4078 33.4617 74.6517C33.3698 74.8935 33.2365 75.1287 33.0587 75.3573C32.8809 75.5859 32.6646 75.8013 32.4069 76.0079C32.1491 76.2123 31.8558 76.4036 31.5269 76.5772C31.201 76.7531 30.8424 76.9091 30.4573 77.0454C30.0721 77.1839 29.6662 77.2982 29.2365 77.3927C28.8069 77.4872 28.3654 77.5597 27.9121 77.6081C27.4558 77.6565 26.9966 77.6806 26.5343 77.6806C26.0692 77.6806 25.6099 77.6565 25.1566 77.6081C24.7003 77.5597 24.2588 77.4872 23.8292 77.3927C23.4025 77.2982 22.9936 77.1839 22.6085 77.0454C22.2233 76.9091 21.8648 76.7531 21.5388 76.5772C21.2099 76.4036 20.9166 76.2123 20.6588 76.0079C20.4011 75.8013 20.1848 75.5859 20.007 75.3573C19.8292 75.1287 19.6959 74.8935 19.604 74.6517C19.5151 74.4078 19.4707 74.1638 19.4707 73.9176C19.4707 73.6692 19.5151 73.4252 19.604 73.1812C19.6959 72.9395 19.8292 72.7043 20.007 72.4757C20.1848 72.2471 20.4011 72.0317 20.6588 71.8251C20.9166 71.6206 21.2099 71.4294 21.5388 71.2558C21.8648 71.0799 22.2233 70.9239 22.6085 70.7876C22.9936 70.6491 23.4025 70.5348 23.8292 70.4403C24.2588 70.3458 24.7003 70.2732 25.1566 70.2249C25.6099 70.1765 26.0692 70.1523 26.5343 70.1523C26.9966 70.1523 27.4558 70.1765 27.9121 70.2249C28.3654 70.2732 28.8069 70.3458 29.2365 70.4403C29.6662 70.5348 30.0721 70.6491 30.4573 70.7876C30.8424 70.9239 31.201 71.0799 31.5269 71.2558C31.8558 71.4294 32.1491 71.6206 32.4069 71.8251C32.6646 72.0317 32.8809 72.2471 33.0587 72.4757C33.2365 72.7043 33.3698 72.9395 33.4617 73.1812C33.5506 73.4252 33.598 73.6692 33.598 73.9176Z",
    fill: "#FA5B5B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_12218_20790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 30,
    width: 25,
    height: 24
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9082 30.9375H53.0013V53.7378H29.9082V30.9375Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_12218_20790)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_12218_20790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 30,
    width: 25,
    height: 24
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4577 30.9414C35.0785 30.9414 29.9111 36.0432 29.9111 42.3416C29.9111 48.637 35.0785 53.7417 41.4577 53.7417C47.8339 53.7417 53.0042 48.637 53.0042 42.3416C53.0042 36.0432 47.8339 30.9414 41.4577 30.9414Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_12218_20790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9111 30.9414H53.0042V53.7417H29.9111V30.9414Z",
    fill: "#F8F3F3"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_12218_20790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 35,
    width: 15,
    height: 15
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2432 35.2148H48.646V49.4351H34.2432V35.2148Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_12218_20790)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_12218_20790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 35,
    width: 15,
    height: 15
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4441 35.2148C37.4649 35.2148 34.2412 38.3976 34.2412 42.3264C34.2412 46.2523 37.4649 49.4351 41.4441 49.4351C45.4204 49.4351 48.644 46.2523 48.644 42.3264C48.644 38.3976 45.4204 35.2148 41.4441 35.2148Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_12218_20790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2412 35.2148H48.644V49.4351H34.2412V35.2148Z",
    fill: "#3D1F1E"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8282 44.1692C43.8282 42.4581 45.1203 41.2246 46.8156 41.2246C45.1991 41.2246 43.8296 39.9107 43.8296 38.2787C43.8296 39.8952 42.5516 41.2246 40.8408 41.2246C42.5516 41.2246 43.8282 42.5202 43.8282 44.1692Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8282 38.2773L43.8296 38.2787M43.8296 38.2787C43.8296 39.9107 45.1991 41.2246 46.8156 41.2246C45.1203 41.2246 43.8282 42.4581 43.8282 44.1692C43.8282 42.5202 42.5516 41.2246 40.8408 41.2246C42.5516 41.2246 43.8296 39.8952 43.8296 38.2787Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12218_20790",
    x1: 13.0815,
    y1: 20.4688,
    x2: 13.0815,
    y2: 41.6835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12218_20790",
    x1: 26.2539,
    y1: 0.15625,
    x2: 26.2539,
    y2: 30.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12218_20790",
    x1: 39.9658,
    y1: 20.4688,
    x2: 39.9658,
    y2: 41.6835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12218_20790",
    x1: 26.5128,
    y1: 32.3984,
    x2: 26.5128,
    y2: 91.0053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FFDE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19F10"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPikko3D);
export default __webpack_public_path__ + "static/media/Pikko3D.7faaec57d20034fc4d1abff7721d1de6.svg";
export { ForwardRef as ReactComponent };